<template>
    <div class="col-xl-12 float-left background-fff mb-3 roi-widget padding15">
        <h6 class="proxima-nova-bold mb-3">Due & Overdue Invoices</h6>
        <payment-modal :invoices="xInvoices"/>
        <invoices
            :invoices="xInvoices"
            :show-client="showClient"
            :show-order="showOrder"
            :id="id"
        />
    </div>
</template>

<script>
    export default {
        props: ['invoices', 'showClient', 'showOrder','id'],
        data() {
            return {
                xInvoices: [],
            };
        },
        watch: {
            invoices(newVal) {
                this.xInvoices = newVal;
            },
        },
        mounted () {
            this.xInvoices = this.invoices;
        },
    }
</script>
